import React from 'react';
import PropTypes from 'prop-types';
import { ALLOWED_AUDIO_RECORDING_URLS } from '@medflex/utils/constants';
import Player from '../VoiceMessage/Player';
import Link from '../Link';

const isPlayableUrl = url => {
  const urlObj = new URL(url);
  if (ALLOWED_AUDIO_RECORDING_URLS.includes(urlObj.hostname)) return true;

  return false;
};

const AudioRecordingUrl = ({ url, recordingTitle, recordingLink }) => {
  if (isPlayableUrl(url)) {
    return (
      <div className="flex flex-row flex-wrap gap-4">
        <div
          className="flex mb-2 bg-slate-50 items-center p-2 w-full first:ml-0"
          key="AudioRecording"
        >
          <Player src={url} caption={recordingTitle} defer />
        </div>
      </div>
    );
  }

  return (
    <Link href={url} target="_blank" rel="noreferrer">
      {recordingLink}
    </Link>
  );
};

AudioRecordingUrl.propTypes = {
  url: PropTypes.string.isRequired,
  recordingTitle: PropTypes.string.isRequired,
  recordingLink: PropTypes.string.isRequired,
};

export default AudioRecordingUrl;
